import React from 'react';
import { cn } from '../../lib/utils';
import './GoodThingsLine.css';

interface GoodThingsLineProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'compact';
}

export const GoodThingsLine: React.FC<GoodThingsLineProps> = ({ 
  children, 
  className,
  variant = 'default'
}) => {
  // Get the gap size based on variant
  const gapSize = variant === 'compact' ? 'space-y-3' : 'space-y-4';
  
  return (
    <div className={cn("w-full flex flex-col", gapSize, className)}>
      {React.Children.map(children, (child) => (
        child && (
          <div className="line-item">
            {child}
          </div>
        )
      ))}
    </div>
  );
};
